<template>
  <div>
    <v-select
      dense
      item-text="name"
      item-value="id"
      outlined
      v-model="selection"
      :label="$t('menu.selection.select_an_option')"
      :items="options"
      :disabled="loading"
      :rules="rules"
      @change="handleChange"
    />

    <LinkedFindingWarningDialog
      :show="openWarningModal"
      @cancel="handleCancel"
      @continue="handleContinue"
    />
  </div>
</template>

<script>
import LinkedFindingWarningDialog from './LinkedFindingWarning.vue'

export default {
  name: 'SelectForm',

  components: {
    LinkedFindingWarningDialog,
  },

  data() {
    return {
      selection: this.response,
      selectionBeforeModal: this.response,
      openWarningModal: false,
    }
  },

  props: {
    options: {
      type: Array,
      required: true,
    },

    response: {
      type: String, // Option id
      required: false,
    },
    loading: Boolean,
    rules: {
      type: Array,
      default: () => [],
    },
    hasFinding: Boolean,
  },

  methods: {
    handleChange(val) {
      if (this.hasFinding) {
        this.openWarningModal = true
      } else {
        this.selection = val
        this.selectionBeforeModal = val
        this.$emit('change', val)
      }
    },

    handleContinue() {
      this.selectionBeforeModal = this.selection
      this.$emit('handleWarningContinue', this.selection)
      this.openWarningModal = false
    },

    handleCancel() {
      this.selection = this.selectionBeforeModal
      this.openWarningModal = false
    },
  },
}
</script>
